import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "../styles/style.css";
import { auth, db, logout } from "../firebase";
import {
  query,
  collection,
  getDocs,
  where,
  updateDoc,
} from "firebase/firestore";
import { Link } from "react-router-dom";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";
import fundamentals_poster from "../assets/images/fundamentals_poster.png";
import ts_rm_poster from "../assets/images/ts_rm_poster.png";
import roadsafety_poster from "../assets/images/road_safety_poster.png";
import fpv_poster from "../assets/images/fpv_poster.png";
import Footer from "../components/footer/footer";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

function Dashboard() {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const navigate = useNavigate();

  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setName(data.name);

      // Check if the user has seen the modal before
      const hasSeenModal = data.hasSeenModal || false;

      if (!hasSeenModal) {
        // If the user has not seen the modal, show it
        setIsNewUser(true);
        // Update the user data to mark that the modal has been seen
        await updateDoc(doc.docs[0].ref, { hasSeenModal: true });
      }
    } catch (err) {
      console.error(err);
      alert("An error occurred while fetching user data");
    }
  };

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserName();
  }, [user, loading]);

  const handleProceedToProgress = () => {
    // Navigate to the progress page when the user clicks on the "Proceed" button
    navigate("/pretest");
  };
  return (
    <div className={`container-dashboard ${isNewUser ? "modal-open" : ""}`}>
      <NavbarDashboard />
      <div className="container-dashboard-content">
        <div className="greetings">
          <h1> Welcome {name}, What do you want to learn today?</h1>
        </div>

        <div className="wrapper">
          <Link to="/fundamentals" className="card cardAnimate animate-delay-0">
            <div className="card-title">
              <h1>Fundamentals</h1>
            </div>

            <img src={fundamentals_poster}></img>
            <div className="info">
              <h1>Fundamentals</h1>
              <p>
                When it comes to mastering driving, a strong grasp of the
                fundamentals is essential. This course includes lessons
                regarding Traffic Lights, Signals, Braking, Turning, etc.
              </p>
              <a href="#" className="btn">
                Read More
              </a>
            </div>
          </Link>

          <Link to="/ts_rm_main" className="card cardAnimate animate-delay-1">
            <img src={ts_rm_poster}></img>
            <div className="info">
              <h1>Traffic Signs and Road Markings</h1>
              <p>
                Traffic signs and road markings are essential elements of any
                well-organized transportation system. It provides crucial
                information to drivers and pedestrians alike. These visual cues
                help prevent accidents, control traffic flow, and guide road
                users safely to their destinations.
              </p>
              <a href="#" className="btn">
                Read More
              </a>
            </div>
          </Link>

          <Link to="/road_safety" className="card cardAnimate animate-delay-2">
            <img src={roadsafety_poster}></img>
            <div className="info">
              <h1>Road Safety</h1>
              <p>This lesson covers all the topics regarding Road Safety.</p>
              <a href="#" className="btn">
                Read More
              </a>
            </div>
          </Link>

          <Link to="/fpv" className="card cardAnimate animate-delay-3">
            <img src={fpv_poster}></img>
            <div className="info">
              <h1>Fines, Penalties, and Violations</h1>
              <p>
                This lesson covers all the violations, penalties, and fines in
                the Philippines when driving a vehicle.
              </p>
              <a href="#" className="btn">
                Read More
              </a>
            </div>
          </Link>
        </div>

        <Modal
          open={isNewUser}
          onClose={() => setIsNewUser(false)}
          BackdropComponent={Backdrop}
          BackdropProps={{
            style: { backdropFilter: "blur(5px)" },
            onClick: null, // Disable click outside to close
          }}
          className="modal-wrapper"
        >
          <Box className="modal-content">
            <Typography variant="h5">Hello, {name}!</Typography>
            <Typography>
              It looks like you are a new user. Please proceed to the progress
              page to take the Pre-Test Assessment.
            </Typography>
            <Button onClick={handleProceedToProgress} className="modal-button">
              Proceed to Pretest Assessment
            </Button>
          </Box>
        </Modal>

        <div className="container-dashboard-content-ind">
          <div className="page-selector-wrapper">
            {/* <Link
              to="/dashboard"
              className="page-selector page-selector--active"
            >
              1
            </Link>
            <Link to="/dashboard-page-2" className="page-selector">
              2
            </Link>
            <Link to="#" className="page-selector">
              3
            </Link> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
export default Dashboard;
